import { ThemeModeContext } from '@/context/ThemeContext';
import { useContext } from 'react';

export const useThemeMode = () => useContext(ThemeModeContext);
